import { Attrs, StofuConfig } from '../indicators/configs/stofu'
import { MainCalculation } from './main'

type DefaultCalculatedValuesType = {
  k: number[]
  d: number[]
}

export class StofuCalculation extends MainCalculation<Attrs, DefaultCalculatedValuesType> {
  static config = StofuConfig

  calculate() {
    const { period, dPeriod, kPeriod } = this.options
    const { high, low, close } = this.quote

    this._calculatedValues = this.getDefaultCalculatedValues()

    const maxPeriod = Math.min(period, close.length - 1)
    let dCount, dSum, k
    const k1 = []

    let kSum = (dSum = 0)
    let kCount = (dCount = 0)
    for (let i = 0; i < close.length; i++) {
      let highestHigh = high[i]
      let lowestLow = low[i]

      for (let j = i - maxPeriod + 1; j <= i; j++) {
        if (high[j] > highestHigh) {
          highestHigh = high[j]
        }
        if (low[j] < lowestLow) {
          lowestLow = low[j]
        }
      }

      k = ((close[i] - lowestLow) / (highestHigh - lowestLow)) * 100
      if (highestHigh === lowestLow) {
        k = 100
      }
      k1[i] = k
      if (kPeriod > 1) {
        kSum += k
        kCount++
        if (kCount > kPeriod) {
          kSum -= k1[i - kPeriod]
          kCount--
        }
        k = kSum / kCount
      }

      dSum += k
      dCount++
      if (dCount > dPeriod) {
        dSum -= this._calculatedValues.k[i - dPeriod]
        dCount--
      }

      const d = dSum / dCount
      this._calculatedValues.k[i] = k
      this._calculatedValues.d[i] = d
    }
  }
}
